export default __webpack_public_path__ + "static/media/cat.a392d7f6.gif";